import { callAPI } from "../../network/networkConnection";

const BASE = process.env.REACT_APP_APIUrl + "admin/map-orders";

const getMapOrders = (queryParams) => {
  return callAPI(BASE + queryParams, "GET", { "Content-Type": "application/json" }, null);
};

const uploadMapOrders = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(BASE + "/upload", "POST", {}, formData)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const updateMapOrderRemark = (id, remark) => {
  return callAPI(
    BASE + `/${id}/remark`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify({ remark })
  );
};

const updateMapOrderStatus = (id, data) => {
  return callAPI(
    BASE + `/${id}/status`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(data)
  );
};

const deleteMapOrder = (id) => {
  return callAPI(BASE + `/${id}`, "DELETE", {}, {});
};

export const mapOrderApiService = {
  getMapOrders,
  uploadMapOrders,
  updateMapOrderRemark,
  updateMapOrderStatus,
  deleteMapOrder,
};
